module.exports = __webpack_public_path__ + "static/media/12.c6b806de.mp3";